module.exports = __webpack_public_path__ + "static/media/noun_X_1890803.74394dca.svg";